const menuButton = document.querySelector<HTMLButtonElement>(".js-menuButton");
const menuCloseButton = document.querySelector<HTMLButtonElement>(".js-menuCloseButton");
const sideMenu = document.querySelector<HTMLElement>(".js-sideMenu");
const body = document.body;

function openSideMenu(e: Event) {
  e.preventDefault();
  body.classList.add("noScroll");
  sideMenu?.classList.remove("hidden");
  menuButton?.classList.add("hidden");
  menuCloseButton?.classList.remove("hidden");
}

function closeSideMenu() {
  body.classList.remove("noScroll");
  sideMenu?.classList.add("hidden");
  menuButton?.classList.remove("hidden");
  menuCloseButton?.classList.add("hidden");
}

menuButton?.addEventListener("click", openSideMenu);
menuCloseButton?.addEventListener("click", closeSideMenu);
